import { DefaultUrlSerializer, UrlTree } from "@angular/router";

/**
 * Removes trailing slashes from the path portion of a URL, leaving the query string
 * and fragment untouched. The root path stays `/`.
 */
export function stripTrailingSlashes(url: string): string {
  const separatorIndex = url.search(/[?#]/);
  const path = separatorIndex === -1 ? url : url.slice(0, separatorIndex);
  const rest = separatorIndex === -1 ? "" : url.slice(separatorIndex);

  const trimmedPath = path.replace(/\/+$/, "");
  if (trimmedPath === "") {
    // Either the url had no path at all (e.g. "?token=t"), which we leave as-is, or the
    // path was only slashes, which normalizes to the root.
    return path === "" ? url : "/" + rest;
  }

  return trimmedPath + rest;
}

/**
 * `DefaultUrlSerializer` turns a trailing slash into an extra empty segment, so
 * `/verify-email/?userId=1&token=t` parses to the segments `["verify-email", ""]` and no
 * longer matches the terminal `verify-email` route — the navigation falls through to the
 * wildcard redirect and the token in the link is lost.
 *
 * Emails already delivered with that URL shape can only be recovered on the client, so we
 * normalize the trailing slash away before delegating to the default serializer. This covers
 * every route, including ones added later.
 */
export class TrailingSlashUrlSerializer extends DefaultUrlSerializer {
  override parse(url: string): UrlTree {
    return super.parse(stripTrailingSlashes(url));
  }
}
